import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import ButtonFilter from '../../atoms/ButtonFilter';
import ButtonHideCompleted from '../../atoms/ButtonHideCompleted';
import ButtonImport from '../../atoms/ButtonImport';
import ButtonNewItem from '../../atoms/ButtonNewItem';
import PageHeader from '../../atoms/PageHeader';
import SearchInput from '../SearchInput';
import ButtonNewItemFromDownload from '../../atoms/ButtonNewItemFromDownload';

const TablePageHeader = props => {
  const {
    completeItemsCount,
    createdNewItem,
    filterOptions,
    hasFilterButton,
    handleImport,
    hasImportButton,
    handleSearch,
    hasSearchInput,
    hasToggleHideCompletedButton,
    isCompleteItemHidden,
    isPremium,
    isPublic,
    itemName,
    newItems,
    uploadGeojson,
    searching,
    toggleDisplayCompleted
  } = props;
  let finalItemName = '';
  if (newItems.length === 1) {
    finalItemName = newItems[0].itemName;
  } else {
    finalItemName = itemName;
  }

  const noHeader = isEmpty(newItems) && !hasImportButton && !hasSearchInput;
  if (noHeader) return '';
  return (
    <PageHeader>
      {hasToggleHideCompletedButton && (
        <ButtonHideCompleted
          isCompleteItemHidden={isCompleteItemHidden}
          toggleDisplayCompleted={toggleDisplayCompleted}
          completeItemsCount={completeItemsCount}
          searching={searching}
          itemName={finalItemName}
        />
      )}
      <div className="ml-auto">
        {hasFilterButton && <ButtonFilter filterOptions={filterOptions} />}
        {hasImportButton && (
          <ButtonImport
            hasImportButton={hasImportButton}
            searching={searching}
            handleImport={handleImport}
            isPremium={isPremium}
            itemName={finalItemName}
          />
        )}
        {!isEmpty(newItems) && !isPublic && (
          <>
            <ButtonNewItem
              isPremium={isPremium}
              newItems={newItems}
              createdNewItem={createdNewItem}
            />
            {uploadGeojson === true && createdNewItem === true && (
              <ButtonNewItemFromDownload {...props} />
            )}
          </>
        )}
        {hasSearchInput && (
          <SearchInput placeholder={`Search ${finalItemName}...`} onKeyUp={handleSearch} />
        )}
      </div>
    </PageHeader>
  );
};

TablePageHeader.propTypes = {
  createdNewItem: PropTypes.bool,
  completeItemsCount: PropTypes.number,
  filterOptions: PropTypes.object,
  handleImport: PropTypes.func,
  handleSearch: PropTypes.func,
  hasFilterButton: PropTypes.bool,
  hasImportButton: PropTypes.bool,
  hasSearchInput: PropTypes.bool,
  hasToggleHideCompletedButton: PropTypes.bool,
  isCompleteItemHidden: PropTypes.bool,
  isPremium: PropTypes.bool.isRequired,
  isPublic: PropTypes.bool,
  itemName: PropTypes.string,
  newItems: PropTypes.array.isRequired,
  searching: PropTypes.bool,
  toggleDisplayCompleted: PropTypes.func,
  uploadGeojson: PropTypes.bool,
  layerList: PropTypes.array
};

TablePageHeader.defaultProps = {
  createdNewItem: true,
  completeItemsCount: 0,
  filterOptions: {},
  handleImport: () => {
    console.error('Unreachable code');
  },
  handleSearch: () => {
    console.error('Unreachable code');
  },
  hasFilterButton: false,
  hasImportButton: false,
  hasSearchInput: false,
  hasToggleHideCompletedButton: false,
  isCompleteItemHidden: false,
  isPublic: false,
  itemName: 'items',
  searching: false,
  toggleDisplayCompleted: () => {
    console.error('Unreachable code');
  },
  uploadGeojson: false,
  layerList: []
};

export default TablePageHeader;
